import { useEffect } from 'react';
import type { LsoDetailsResponse } from 'src/apis/organisation-service/types';
import type { OrganisationDetailsRequest } from 'src/apis/organisation-service/use-organisation-details';
import { useAxios } from 'src/hooks/use-axios';

export function useLsoDetails({
  organisationDetails,
}: {
  organisationDetails: OrganisationDetailsRequest;
}) {
  const request = useAxios(
    (axios, baseConfig, url: string) =>
      axios.request<LsoDetailsResponse>({
        ...baseConfig,
        url,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (
      organisationDetails.response &&
      organisationDetails.response.data._links.lsoDetails
    ) {
      request.execute(organisationDetails.response.data._links.lsoDetails.href);
    } else {
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organisationDetails.response]);

  return request;
}

export type LsoDetailsRequest = ReturnType<typeof useLsoDetails>;
